import { motion } from "framer-motion";
import { GALLERY } from "@/data/site";

export default function GalleryPage() {
  return (
    <div data-testid="gallery-page">
      <section className="border-b border-white/10 bg-[#111] relative grain">
        <div className="max-w-7xl mx-auto px-6 py-24">
          <p className="label-industrial text-ember mb-4">Gallery</p>
          <h1 className="font-display text-6xl lg:text-8xl tracking-wide text-white" data-testid="gallery-heading">
            FROM THE FLOOR
          </h1>
          <p className="mt-6 text-gray-400 max-w-xl">
            Builds, repairs and fabrication straight off the workshop floor in Whangamata.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="gallery-grid">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 3) * 0.08 }}
              className="group relative aspect-[4/3] overflow-hidden border border-white/10"
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={g.src}
                alt={g.caption}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-black/70 px-4 py-3 translate-y-full group-hover:translate-y-0 transition-transform duration-200">
                <span className="label-industrial text-ember">{g.caption}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </section>
    </div>
  );
}
